/*
  h26-shared.js: Harvest 2026 collection page + ads landing page, the one shared script.
  Loaded once per page (deferred) by snippets/h26-shared-boot.liquid, after h26-events.js and
  h26-atc.js (foundation, not edited here). Everything is in-place DOM updates: taps never
  re-render a section, reset a carousel or move the page.

    carousels      [data-h26s-car]: arrows, "1-2 of 5", swipe, keyboard (arrow keys on the focused
                   track); static when the cards fit. oo_carousel_move {carousel, method, from, to,
                   farmer_id on the LP farmers row}.
    milestones     [data-h26s-ms]: a tap opens that stage's message (oo_milestone_tap from markup).
    reviews        [data-h26s-rv]: topic chips filter the row; collection "Read all" opens the side
                   panel (dialog: focus moves in, Tab stays in, Escape closes, focus returns), with
                   more store reviews from Judge.me's public all-reviews endpoint.
    grid           [data-h26s-grid]: tabs, sort (mild to bold by rank), Show more, the clip band after
                   the second row, the Allocation filled group, Try instead (+ `_source`
                   h26-coll-tryinstead on the target's next add).
    farmers        [data-h26s-farmers]: Read more expands the story under the carousel (no pop-up);
                   LP: the card on screen gets the bronze outline and its map dot pulses.
    taste          [data-h26s-taste]: the scale (tap, drag, keys), the travelling zone label, Closest
                   taste (`_closest=1` on the target's next add).
    sticky         [data-h26s-stk]: after the hero, hidden over the grid and while a drawer, modal,
                   the free-shipping pop-up or the cookie banner is open.
    media          video[data-h26s-video]: nothing downloads until on screen; plays muted inline when
                   half visible, pauses off screen; no autoplay under reduced motion or data saver.
    early access   [data-h26s-ea]: the eyebrow switches at the end instant, checked against UTC.
    live cards     same bottle twice: before a live-card add (UpCart path), its `_source` input takes
                   the existing cart line's value so the line doesn't split (LP spec §5.3).
    links          card_click events; LP product links carry ?oo_src=<placement>.
  Events go through window.OOH26.track (h26-events.js); nothing here sends data anywhere else.
*/
(function () {
  'use strict';
  if (window.OOH26S) return;

  var CFG = window.OO_H26 || {};
  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  var DESK = '(min-width: 760px)';

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }
  function track(n, f, el) { try { if (window.OOH26 && window.OOH26.track) window.OOH26.track(n, f || null, el || null); } catch (e) {} }
  function pat(p, n) { return String(p || '').replace(/\{n\}/g, String(n)); }
  function behavior() { return reduce ? 'auto' : 'smooth'; }
  function isDesk() { try { return window.matchMedia(DESK).matches; } catch (e) { return false; } }
  function highlight(el) { if (!el) return; el.classList.add('is-hl'); setTimeout(function () { el.classList.remove('is-hl'); }, 2200); }

  /* ---------------------------------------------------------------- carousels */
  function gapOf(t) { var cs = getComputedStyle(t); return parseFloat(cs.columnGap) || parseFloat(cs.gap) || 12; }
  function shown(t) { return [].filter.call(t.children, function (x) { return x.offsetParent !== null && x.tagName !== 'SCRIPT'; }); }

  function initCar(c) {
    if (c.__h26s) return;
    var t = $('[data-h26s-track]', c);
    if (!t) return;
    c.__h26s = true;
    var arw = $('[data-h26s-arw]', c);
    var prev = arw && $('[data-dir="-1"]', arw), next = arw && $('[data-dir="1"]', arw), pos = arw && $('.h26s-pos', arw);
    var of = (pos && pos.getAttribute('data-of')) || 'of';
    var name = c.getAttribute('data-h26s-car') || '';
    var last = 1, method = null, settle = null;
    function step() { var f = shown(t)[0]; return f ? f.getBoundingClientRect().width + gapOf(t) : t.clientWidth; }
    function upd() {
      var n = shown(t).length;
      var over = t.scrollWidth > t.clientWidth + 4;
      if (arw) { if (over) arw.removeAttribute('data-off'); else arw.setAttribute('data-off', ''); }
      if (!over) return 1;
      var w = step();
      var vis = Math.max(1, Math.floor((t.clientWidth + gapOf(t)) / w + 0.02));
      var i = Math.min(n, Math.round(t.scrollLeft / w) + 1);
      var end = t.scrollLeft + t.clientWidth >= t.scrollWidth - 4;
      var l = Math.min(n, i + vis - 1);
      if (end) { l = n; i = Math.max(1, n - vis + 1); }
      if (pos) pos.textContent = (i === l ? i : i + '-' + l) + ' ' + of + ' ' + n;
      if (prev) prev.disabled = t.scrollLeft < 4;
      if (next) next.disabled = end;
      return i;
    }
    function moved() {
      var i = upd();
      if (i && i !== last) {
        var f = { carousel: name, method: method || 'swipe', from: last, to: i };
        if (c.__farmerAt) { var fid = c.__farmerAt(i); if (fid) f.farmer_id = fid; }
        track('carousel_move', f, c);
        last = i;
      }
      method = null;
    }
    if (arw) arw.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-dir]');
      if (!b || b.disabled) return;
      method = 'arrow';
      t.scrollBy({ left: (+b.getAttribute('data-dir')) * step(), behavior: behavior() });
    });
    t.addEventListener('keydown', function (e) {
      if (e.target !== t) return;
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault();
        method = 'keyboard';
        t.scrollBy({ left: (e.key === 'ArrowRight' ? 1 : -1) * step(), behavior: behavior() });
      }
    });
    t.addEventListener('scroll', function () {
      upd();
      try { c.dispatchEvent(new CustomEvent('h26s:scroll')); } catch (e) {}
      clearTimeout(settle);
      settle = setTimeout(moved, 160);
    }, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(function () { upd(); }).observe(t);
    else window.addEventListener('resize', upd);
    c.__upd = upd;
    c.__setMethod = function (m) { method = m; };
    last = upd() || 1;
  }

  /* ---------------------------------------------------------------- milestones */
  function initMs(root) {
    if (root.__h26s) return; root.__h26s = true;
    root.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-ms]');
      if (!b) return;
      var i = b.getAttribute('data-ms');
      $$('.h26s-tl li', root).forEach(function (li) {
        var bb = $('button', li), on = bb === b;
        li.classList.toggle('is-on', on);
        bb.setAttribute('aria-expanded', String(on));
      });
      $$('[data-msp]', root).forEach(function (p) { p.hidden = p.getAttribute('data-msp') !== i; });
    });
  }

  /* ---------------------------------------------------------------- reviews */
  function fmtDate(iso) {
    try { var d = new Date(iso); if (isNaN(d)) return ''; return d.toLocaleDateString('en', { month: 'short', year: 'numeric', timeZone: 'UTC' }); } catch (e) { return ''; }
  }
  function parseJdgm(html) {
    var out = [];
    try {
      var doc = new DOMParser().parseFromString(String(html || ''), 'text/html');
      $$('.jdgm-rev', doc).forEach(function (n) {
        var rt = $('.jdgm-rev__rating', n), tm = $('.jdgm-rev__timestamp', n);
        var txt = function (sel) { var x = $(sel, n); return x ? x.textContent.replace(/\s+/g, ' ').trim() : ''; };
        out.push({
          id: n.getAttribute('data-review-id') || '',
          score: rt ? (+rt.getAttribute('data-score') || 0) : 0,
          date: tm ? fmtDate(tm.getAttribute('datetime') || tm.getAttribute('data-content')) : '',
          author: txt('.jdgm-rev__author'), title: txt('.jdgm-rev__title'), body: txt('.jdgm-rev__body')
        });
      });
    } catch (e) {}
    return out;
  }
  function revCard(r) {
    var a = document.createElement('article');
    a.className = 'h26s-rc h26s-rc--full';
    a.setAttribute('data-topic', 'store');
    var q = document.createElement('div'); q.className = 'h26s-rc-q';
    var st = document.createElement('span'); st.className = 'h26s-stars'; st.setAttribute('role', 'img'); st.setAttribute('aria-label', r.score + ' / 5');
    for (var i = 1; i <= 5; i++) { var s = document.createElement('span'); s.textContent = '★'; if (i > r.score) s.className = 'off'; st.appendChild(s); }
    q.appendChild(st);
    if (r.title) { var b = document.createElement('p'); b.style.fontWeight = '500'; b.textContent = r.title; q.appendChild(b); }
    if (r.body) { var p = document.createElement('p'); p.textContent = r.body; q.appendChild(p); }
    a.appendChild(q);
    var w = document.createElement('div'); w.className = 'h26s-rc-who';
    w.textContent = [r.author, r.date].filter(Boolean).join(' · ');
    a.appendChild(w);
    return a;
  }
  function initRv(root) {
    if (root.__h26s) return; root.__h26s = true;
    var chips = $('[data-h26s-rv-chips]', root), car = $('[data-h26s-car]', root), t = car && $('[data-h26s-track]', car);
    if (chips && t) chips.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-topic]');
      if (!b) return;
      var tp = b.getAttribute('data-topic');
      $$('button', chips).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      $$('.h26s-rc', t).forEach(function (r) { r.classList.toggle('is-off', tp !== 'all' && r.getAttribute('data-topic') !== tp); });
      if (car.__setMethod) car.__setMethod('chip');
      t.scrollLeft = 0;
      if (car.__upd) car.__upd();
    });
    var open = $('[data-h26s-rv-open]', root), tpl = $('template[data-h26s-rv-panel]', root);
    if (open && tpl) rvPanel(root, open, tpl);
    if (t && root.getAttribute('data-more')) rvMore(root, t, car);
  }
  // Amir Oct 22 ("30 is fine"): on the LP the row tops up the curated reviews with 5-star written store reviews from
  // Judge.me's public endpoint (same as the collection panel), up to data-more cards in all. Starts when the row nears
  // the screen; skips short or very long reviews and any that repeat a curated quote; topic chips hide them (topic "store").
  function rvMore(root, t, car) {
    var want = +root.getAttribute('data-more') || 0, shop = root.getAttribute('data-shop') || '', page = 0, seen = {}, started = false;
    function norm(x) { return String(x || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }
    function have() { return $$('.h26s-rc', t).length; }
    if (!shop || have() >= want) return;
    var known = $$('.h26s-rc-q p', t).map(function (p) { return norm(p.textContent).slice(0, 40); }).filter(Boolean);
    function done() { if (car.__upd) car.__upd(); track('reviews_load_result', { outcome: 'success', count: have(), index: page }, root); }
    function next() {
      page++;
      if (page > 8 || have() >= want) return done();
      fetch('https://api.judge.me/reviews/all_reviews_js_based?shop_domain=' + encodeURIComponent(shop) + '&platform=shopify&page=' + page + '&per_page=25',
        { method: 'GET', credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
        .then(function (j) {
          var got = parseJdgm(j && j.html);
          var on = $('[data-h26s-rv-chips] button[aria-pressed="true"]', root), tp = on ? on.getAttribute('data-topic') : 'all';
          got.forEach(function (x) {
            if (have() >= want || x.score < 5 || x.body.length < 40 || x.body.length > 420 || (x.id && seen[x.id])) return;
            if (x.id) seen[x.id] = 1;
            var nb = norm(x.body);
            if (known.some(function (k) { return nb.indexOf(k) >= 0; })) return;
            var card = revCard(x);
            card.className = 'h26s-rc' + (tp !== 'all' ? ' is-off' : '');
            t.appendChild(card);
          });
          if (car.__upd) car.__upd();
          if (!got.length) return done();
          next();
        }).catch(function () { track('reviews_load_result', { outcome: 'error', error_code: 'judgeme_endpoint' }, root); });
    }
    function go() { if (started) return; started = true; next(); }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); go(); } }, { rootMargin: '800px 0px' });
      io.observe(root);
    } else go();
  }
  function rvPanel(root, btn, tpl) {
    var nodes = null, panel = null;
    var st = { page: 0, done: false, failed: false, loading: false, filter: 'all', seen: {} };
    var kept = [];
    function list() { return $('[data-h26s-rvp-list]', panel); }
    function paintFilter() {
      $$('.h26s-rc', list()).forEach(function (r) { r.classList.toggle('is-off', st.filter !== 'all' && r.getAttribute('data-topic') !== st.filter); });
    }
    function paintState() {
      $('[data-h26s-rvp-loading]', panel).hidden = !st.loading;
      $('[data-h26s-rvp-fail]', panel).hidden = !st.failed;
      $('[data-h26s-rvp-more]', panel).hidden = st.done || st.failed || st.loading;
    }
    function load() {
      if (st.loading || st.done || !panel) return;
      st.loading = true; paintState();
      var page = st.page + 1;
      var per = Math.min(25, Math.max(5, +panel.getAttribute('data-per-page') || 10));
      var url = 'https://api.judge.me/reviews/all_reviews_js_based?shop_domain=' + encodeURIComponent(panel.getAttribute('data-shop') || '') +
        '&platform=shopify&page=' + page + '&per_page=' + per;
      fetch(url, { method: 'GET', credentials: 'omit' }).then(function (r) {
        if (!r.ok) throw new Error('http ' + r.status);
        return r.json();
      }).then(function (j) {
        var got = parseJdgm(j && j.html);
        var added = 0;
        got.forEach(function (x) {
          if (x.id && st.seen[x.id]) return;
          if (x.id) st.seen[x.id] = 1;
          var card = revCard(x);
          kept.push(card);
          if (panel) list().appendChild(card);
          added++;
        });
        st.page = page;
        if (!got.length || !added) st.done = true;
        track('reviews_load_result', { outcome: 'success', count: added, index: page }, panel);
      }).catch(function () {
        st.failed = true;
        track('reviews_load_result', { outcome: 'error', error_code: 'judgeme_endpoint' }, panel);
      }).then(function () {
        st.loading = false;
        if (panel) { paintFilter(); paintState(); }
      });
    }
    function close() {
      if (!nodes) return;
      nodes.forEach(function (n) { if (n.parentNode) n.parentNode.removeChild(n); });
      nodes = null; panel = null;
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', onKey, true);
      try { btn.focus(); } catch (e) {}
    }
    function onKey(e) {
      if (!panel) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key === 'Tab') {
        var f = $$('button,a[href],[tabindex="0"]', panel).filter(function (x) { return x.offsetParent !== null && !x.disabled; });
        if (!f.length) return;
        var a = f[0], b = f[f.length - 1];
        if (e.shiftKey && (document.activeElement === a || !panel.contains(document.activeElement))) { e.preventDefault(); b.focus(); }
        else if (!e.shiftKey && (document.activeElement === b || !panel.contains(document.activeElement))) { e.preventDefault(); a.focus(); }
      }
    }
    btn.addEventListener('click', function () {
      if (nodes) return;
      var frag = tpl.content.cloneNode(true);
      nodes = [].slice.call(frag.children);
      document.body.appendChild(frag);
      panel = nodes.filter(function (n) { return n.tagName === 'ASIDE'; })[0];
      kept.forEach(function (c) { list().appendChild(c); });
      document.documentElement.style.overflow = 'hidden';
      nodes.forEach(function (n) { n.addEventListener('click', function (e) { if (e.target.closest('[data-h26s-rv-close]')) close(); }); });
      var chips = $('[data-h26s-rvp-chips]', panel);
      if (chips) chips.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-topic]');
        if (!b) return;
        st.filter = b.getAttribute('data-topic');
        $$('button', chips).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        paintFilter();
      });
      $('[data-h26s-rvp-more]', panel).addEventListener('click', load);
      document.addEventListener('keydown', onKey, true);
      try { if (window.OOH26 && window.OOH26.observe) window.OOH26.observe(panel); } catch (e) {}
      var x = $('.h26s-x', panel); if (x) x.focus();
      paintFilter(); paintState();
      if (!st.page && !st.failed) load();
    });
  }

  /* ---------------------------------------------------------------- live cards: same bottle twice */
  var syncT = null;
  function syncSources() { clearTimeout(syncT); syncT = setTimeout(doSync, 150); }
  function doSync() {
    var forms = $$('.h26s [data-oo-atc-form]');
    if (!forms.length) return;
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c) return;
        var map = {};
        (c.items || []).forEach(function (l) {
          if (l.selling_plan_allocation || Object.prototype.hasOwnProperty.call(map, l.variant_id)) return;
          map[l.variant_id] = (l.properties && l.properties._source) || '';
        });
        forms.forEach(function (f) {
          var id = $('[name="id"]', f), s = $('[name="properties[_source]"]', f);
          if (!id || !s) return;
          if (!s.hasAttribute('data-h26s-def')) s.setAttribute('data-h26s-def', s.value);
          var vid = +id.value;
          if (Object.prototype.hasOwnProperty.call(map, vid)) {
            if (map[vid]) { s.value = map[vid]; s.disabled = false; } else { s.disabled = true; }
          } else {
            s.disabled = false;
            s.value = s.getAttribute('data-h26s-ovr') || s.getAttribute('data-h26s-def');
          }
        });
      }).catch(function () {});
  }

  /* ---------------------------------------------------------------- grid */
  var GRIDS = [];
  function initGrid(g) {
    if (g.__h26s) return; g.__h26s = true;
    var live = $('[data-h26s-live]', g), gone = $('[data-h26s-gone]', g), sel = $('[data-h26s-sort]', g),
      more = $('[data-h26s-more]', g), cnt = $('[data-h26s-count]', g), af = $('[data-h26s-af]', g), clip = $('[data-h26s-clip]', g);
    var per = +g.getAttribute('data-per') || 8;
    var st = { tab: 'all', sort: 'feat', show: per };   // Amir Oct 19: All opens on Featured (the collection's own order); Oils on mild to bold
    var items = $$('[data-h26s-gi]', live), goneItems = gone ? $$('[data-h26s-gi]', gone) : [];
    var KIND = { all: null, oils: 'oil', sets: 'set', spices: 'spice' };
    var BASE = { oil: 5000, set: 10000, spice: 20000, other: 30000 };
    function rank(x) { var r = parseFloat(x.getAttribute('data-rank')); return isNaN(r) ? null : r; }
    function feat(x) { return +x.getAttribute('data-feat') || 0; }
    function key(x) {
      var k = x.getAttribute('data-kind'), r = rank(x), p = +x.getAttribute('data-price') || 0;
      switch (st.sort) {
        case 'mild': return k === 'oil' && r !== null ? r : (BASE[k] || 30000) + feat(x);
        case 'bold': return k === 'oil' && r !== null ? -r : (BASE[k] || 30000) + feat(x);
        case 'low': return p;
        case 'high': return -p;
        default: return feat(x);
      }
    }
    function match(x) { var k = KIND[st.tab]; return !k || x.getAttribute('data-kind') === k; }
    function syncSortOptions() {
      if (!sel) return;
      var ok = false;
      $$('option', sel).forEach(function (o) {
        var on = (o.getAttribute('data-on') || '').split(',').indexOf(st.tab) !== -1;
        o.hidden = !on; o.disabled = !on;
        var la = o.getAttribute('data-label-all'), l1 = o.getAttribute('data-label-one');
        if (la && l1) o.textContent = st.tab === 'all' ? la : l1;
        if (on && o.value === st.sort) ok = true;
      });
      if (!ok) st.sort = 'feat';
      sel.value = st.sort;
    }
    function placeClip(L) {
      if (!clip) return;
      var at = (isDesk() ? 4 : 2) * 2;
      var visible = Math.min(L.length, st.show);
      if (visible > at) { live.insertBefore(clip, L[at]); clip.hidden = false; }
      else { live.appendChild(clip); clip.hidden = true; }
    }
    function apply() {
      var L = items.filter(match).sort(function (a, b) { return key(a) - key(b) || feat(a) - feat(b); });
      items.forEach(function (x) { if (!match(x)) x.hidden = true; });
      L.forEach(function (x, i) { live.appendChild(x); x.hidden = i >= st.show; });
      placeClip(L);
      if (cnt) cnt.textContent = pat(g.getAttribute('data-count-pat'), L.length);
      var rest = L.length - st.show;
      if (more) {
        if (rest > 0) { more.hidden = false; more.textContent = pat(g.getAttribute('data-more-pat'), rest); more.setAttribute('data-h26-count', String(Math.min(per, rest))); }
        else more.hidden = true;
      }
      if (gone && af) {
        var G = goneItems.filter(match).sort(function (a, b) { return feat(a) - feat(b); });
        goneItems.forEach(function (x) { x.hidden = !match(x); });
        G.forEach(function (x) { gone.appendChild(x); });
        af.hidden = G.length === 0;
        var sm = $('summary', af); if (sm) sm.textContent = pat(g.getAttribute('data-filled-pat'), G.length);
      }
    }
    function setTab(tab) {
      st.tab = tab;
      st.show = per;
      if (tab === 'oils' && st.sort === 'feat') st.sort = 'mild';
      $$('[data-tab]', g).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-tab') === tab)); });
      syncSortOptions();
      apply();
    }
    g.addEventListener('click', function (e) {
      var tb = e.target.closest('[data-tab]');
      if (tb && g.contains(tb)) { setTab(tb.getAttribute('data-tab')); return; }
      if (e.target.closest('[data-h26s-more]')) { st.show += per; apply(); return; }
      var tl = e.target.closest('[data-h26s-try-link]');
      if (tl) {
        e.preventDefault();
        var target = tl.__target;
        if (!target) return;
        setTab('all');
        st.show = items.length; apply();
        target.scrollIntoView({ block: 'center', behavior: behavior() });
        highlight(target);
        if (g.getAttribute('data-page') === 'coll') {
          var s = $('[name="properties[_source]"]', target);
          if (s) { s.setAttribute('data-h26s-ovr', g.getAttribute('data-filled-placement') || ''); syncSources(); }
        }
      }
    });
    if (sel) sel.addEventListener('change', function () {
      st.sort = sel.value; st.show = per; apply();
      track('grid_sort', { sort: st.sort, tab: st.tab }, sel);
    });
    if (af) af.addEventListener('toggle', function () { if (af.open) track('filled_open', { count: goneItems.filter(function (x) { return !x.hidden; }).length }, af); });
    // Try instead: the nearest available oil by rank (olive.similar wins when it points to an available product here)
    goneItems.forEach(function (x) {
      var p = $('[data-h26s-try]', x), a = p && $('[data-h26s-try-link]', p);
      if (!a) return;
      var target = null, sim = x.getAttribute('data-similar');
      if (sim) target = items.filter(function (y) { return y.getAttribute('data-pid') === sim; })[0] || null;
      var r = rank(x);
      if (!target && r !== null) {
        var bd = Infinity;
        items.forEach(function (y) {
          if (y.getAttribute('data-kind') !== 'oil') return;
          var ry = rank(y); if (ry === null) return;
          var d = Math.abs(ry - r);
          if (d < bd) { bd = d; target = y; }
        });
      }
      if (target) {
        a.__target = target;
        a.textContent = target.getAttribute('data-name') || '';
        a.setAttribute('href', '#' + target.id);
        a.setAttribute('data-h26-to', target.getAttribute('data-pid') || '');
        p.hidden = false;
      }
    });
    try { window.matchMedia(DESK).addEventListener('change', function () { apply(); }); } catch (e) {}
    // the tab selected when the page opens (section setting start_tab; LP = Sets, Amir Oct 19)
    var t0 = g.getAttribute('data-start-tab');
    if (t0 && t0 !== 'all' && $('[data-tab="' + t0 + '"]', g)) setTab(t0);
    else { syncSortOptions(); apply(); }
    g.__setTab = setTab;
    GRIDS.push(g);
  }
  function toolbarTop() {
    var tbs = $$('.h26s [data-h26s-tb]');
    if (!tbs.length) return;
    var top = 0;
    $$('.site-header, #HeaderWrapper, [data-section-type="header"]').forEach(function (h) {
      var cs = getComputedStyle(h);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
      var r = h.getBoundingClientRect();
      if (r.top <= 1 && r.bottom > top && r.height < 220) top = r.bottom;
    });
    tbs.forEach(function (t) { t.style.setProperty('--h26s-top', Math.round(top) + 'px'); });
  }

  /* ---------------------------------------------------------------- farmers */
  function initFarmers(sec) {
    if (sec.__h26s) return; sec.__h26s = true;
    var slot = $('[data-h26s-fpan]', sec);
    if (!slot) return;
    function setExpanded(key) {
      $$('[data-h26s-rmore]', sec).forEach(function (r) { r.setAttribute('aria-expanded', String(r.getAttribute('data-h26s-rmore') === key)); });
    }
    function closeP() {
      var k = slot.getAttribute('data-k');
      slot.hidden = true; slot.innerHTML = ''; slot.removeAttribute('data-k');
      setExpanded(null);
      var b = k && $('[data-h26s-rmore="' + k + '"]', sec);
      if (b) try { b.focus({ preventScroll: true }); } catch (e) {}
    }
    sec.addEventListener('click', function (e) {
      if (e.target.closest('[data-h26s-fpan-x]')) { closeP(); return; }
      var b = e.target.closest('[data-h26s-rmore]');
      if (!b) return;
      var key = b.getAttribute('data-h26s-rmore');
      if (!slot.hidden && slot.getAttribute('data-k') === key) { closeP(); return; }
      var tpl = null;
      $$('template[data-h26s-story]', sec).forEach(function (x) { if (x.getAttribute('data-h26s-story') === key) tpl = x; });
      if (!tpl) return;
      slot.innerHTML = '';
      slot.appendChild(tpl.content.cloneNode(true));
      slot.setAttribute('data-k', key);
      slot.hidden = false;
      setExpanded(key);
      track('farmer_panel_open', { farmer_id: key }, b);
      try { if (window.OOH26 && window.OOH26.observe) window.OOH26.observe(slot); } catch (err) {}
      // Review GEM-1-03 (Oct 16): the panel is cloned from a <template>, so converted-currency free-shipping
      // gates inside it are run through the threshold script here (it only saw the page at load).
      try { if (window.H26Thr && window.H26Thr.apply) window.H26Thr.apply(slot); } catch (err) {}
      slot.scrollIntoView({ block: 'nearest', behavior: behavior() });
    });
    // LP: the card on screen gets the outline and its map dot pulses; carousel moves carry its farmer id
    var car = $('[data-h26s-car]', sec), t = car && $('[data-h26s-track]', car);
    var cards = t ? $$('[data-h26s-fs]', t) : [];
    if (cards.length && car) {
      car.__farmerAt = function (i) { var c = cards[i - 1]; return c ? c.getAttribute('data-farmer-id') : null; };
      var onT = null;
      var mark = function () {
        var w = cards[0].getBoundingClientRect().width + gapOf(t);
        var i = Math.min(cards.length - 1, Math.round(t.scrollLeft / w));
        var vis = Math.max(1, Math.round((t.clientWidth + gapOf(t)) / w));
        cards.forEach(function (c, k) { c.classList.toggle('is-on', k >= i && k < i + vis); });
      };
      car.addEventListener('h26s:scroll', function () { clearTimeout(onT); onT = setTimeout(mark, 140); });
      mark();
    }
  }

  /* ---------------------------------------------------------------- taste row */
  function initTaste(sec) {
    if (sec.__h26s) return; sec.__h26s = true;
    var car = $('[data-h26s-car]', sec), t = $('[data-h26s-taste-track]', sec), sc = $('[data-h26s-scale]', sec);
    if (!t || !sc) return;
    var win = $('[data-h26s-win]', sc), tag = $('[data-h26s-stag]', sc), rail = $('.h26s-rail', sc);
    var zones = (sec.getAttribute('data-zones') || 'Mild|Medium|Bold').split('|');
    var ZKEY = ['mild', 'medium', 'bold'];
    var lastZone = null;
    function N() { return t.children.length; }
    function w() { var c = t.firstElementChild; return c ? c.getBoundingClientRect().width + gapOf(t) : 1; }
    function vis() { return Math.max(1, Math.round((t.clientWidth + gapOf(t)) / w())); }
    function first() { var i = Math.round(t.scrollLeft / w()); if (t.scrollLeft + t.clientWidth >= t.scrollWidth - 4) i = Math.max(0, N() - vis()); return Math.max(0, Math.min(N() - 1, i)); }
    function paint() {
      var n = N(), v = vis(), i = first();
      if (!n) return;
      win.style.left = (i / n * 100) + '%';
      win.style.width = (Math.min(v, n - i) / n * 100) + '%';
      var f = (i + v / 2) / n, zi = f < 0.34 ? 0 : f < 0.67 ? 1 : 2;
      tag.querySelector('b').textContent = zones[zi] || '';
      var c0 = t.children[i];
      tag.querySelector('span').textContent = c0 ? (c0.getAttribute('data-t') || '') : '';
      var W = rail.offsetWidth, cx = (i + Math.min(v, n - i) / 2) / n * W, tw = tag.offsetWidth;
      tag.style.left = Math.max(0, Math.min(W - tw, cx - tw / 2)) + 'px';
      if (lastZone !== null && zi !== lastZone) track('taste_zone', { zone: ZKEY[zi] }, sc);
      lastZone = zi;
    }
    function go(k, smooth, m) {
      var n = N(), v = vis();
      if (!n) return;
      var i = Math.max(0, Math.min(Math.max(0, n - v), k - Math.floor(v / 2)));
      if (car && car.__setMethod) car.__setMethod(m || 'scale');
      t.scrollTo({ left: t.children[i].offsetLeft - t.offsetLeft, behavior: smooth && !reduce ? 'smooth' : 'auto' });
    }
    function idx(x) { var r = rail.getBoundingClientRect(); return Math.max(0, Math.min(N() - 1, Math.floor((x - r.left) / r.width * N()))); }
    var drag = false, dragged = false, startX = 0;
    sc.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      drag = true; dragged = false; startX = e.clientX;
      try { sc.setPointerCapture(e.pointerId); } catch (err) {}
      sc.classList.add('is-drag');
      go(idx(e.clientX), false, 'scale');
    });
    sc.addEventListener('pointermove', function (e) {
      if (!drag) return;
      if (Math.abs(e.clientX - startX) > 4) dragged = true;
      go(idx(e.clientX), false, 'scale');
    });
    var end = function () {
      if (!drag) return;
      drag = false; sc.classList.remove('is-drag');
      track('scale_use', { method: dragged ? 'drag' : 'tap' }, sc);
    };
    sc.addEventListener('pointerup', end);
    sc.addEventListener('pointercancel', end);
    sc.addEventListener('click', function (e) {
      var tk = e.target.closest('.h26s-tk');
      if (tk && e.detail === 0) { go(+tk.getAttribute('data-k'), true, 'scale'); track('scale_use', { method: 'key' }, sc); }
    });
    sc.addEventListener('keydown', function (e) {
      if (e.target !== sc) return;
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      if (car && car.__setMethod) car.__setMethod('scale');
      t.scrollBy({ left: (e.key === 'ArrowRight' ? 1 : -1) * w(), behavior: behavior() });
      track('scale_use', { method: 'key' }, sc);
    });
    t.addEventListener('scroll', paint, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(paint).observe(t);
    // Closest taste: the nearest available rank among the cards shown
    var cards = [].slice.call(t.children);
    $$('[data-h26s-closest]', t).forEach(function (b) {
      var card = b.closest('.h26s-pc'), r = parseFloat(card.getAttribute('data-rank'));
      var best = null, bd = Infinity;
      cards.forEach(function (c) {
        if (c.classList.contains('is-out')) return;
        var rr = parseFloat(c.getAttribute('data-rank'));
        if (isNaN(rr) || isNaN(r)) return;
        var d = Math.abs(rr - r);
        if (d < bd) { bd = d; best = c; }
      });
      if (best) {
        b.textContent = (b.getAttribute('data-pattern') || '{oil}').replace('{oil}', best.getAttribute('data-name') || '');
        b.setAttribute('data-h26-to', best.getAttribute('data-pid') || '');
        b.__target = best;
        b.hidden = false;
      } else {
        var none = $('[data-h26s-closest-none]', card); if (none) none.hidden = false;
      }
    });
    t.addEventListener('click', function (e) {
      var b = e.target.closest('[data-h26s-closest]');
      if (!b || !b.__target) return;
      var c = b.__target;
      if (car && car.__setMethod) car.__setMethod('closest');
      t.scrollTo({ left: c.offsetLeft - t.offsetLeft, behavior: behavior() });
      highlight(c);
      var flag = $('[data-h26s-closest-flag]', c); if (flag) flag.disabled = false;
    });
    sec.addEventListener('h26:atc', function (e) {
      var form = e.target, d = e.detail || {};
      if (d.outcome === 'success') { var flag = $('[data-h26s-closest-flag]', form); if (flag) flag.disabled = true; }
    });
    paint();
  }

  /* ---------------------------------------------------------------- sticky bar (LP) */
  function initSticky(bar) {
    if (bar.__h26s) return; bar.__h26s = true;
    var hero = document.getElementById(bar.getAttribute('data-hero')), grid = document.getElementById(bar.getAttribute('data-grid'));
    var st = { hero: true, grid: false }, cartOpen = false, shownOnce = false;
    function visibleEl(el) { if (!el) return false; var cs = getComputedStyle(el); var r = el.getBoundingClientRect(); return cs.display !== 'none' && cs.visibility !== 'hidden' && r.width > 0 && r.height > 0; }
    function blocked() {
      var b = document.body, de = document.documentElement;
      if (cartOpen) return true;
      if (b.classList.contains('oo-scroll-lock')) return true;
      if (de.style.overflow === 'hidden' || b.style.overflow === 'hidden') return true;
      var fsm = $('[data-ratt-fsm]'); if (fsm && !fsm.hidden && visibleEl(fsm)) return true;
      if (visibleEl(document.getElementById('shopify-pc__banner'))) return true;
      if (visibleEl($('.shopify-pc__banner__dialog'))) return true;
      if (visibleEl($('[data-kl-scroll-locking-modal]'))) return true;
      return false;
    }
    function upd() {
      var on = !st.hero && !st.grid && !blocked();
      if (on === !bar.hidden) return;
      bar.hidden = !on;
      bar.setAttribute('aria-hidden', String(!on));
      if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
      document.body.classList.toggle('h26s-stk-on', on);
      if (on && !shownOnce) { shownOnce = true; track('sticky_shown', null, bar); }
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.target === hero) st.hero = e.isIntersecting; if (e.target === grid) st.grid = e.isIntersecting; });
        upd();
      }, { threshold: 0 });
      if (hero) io.observe(hero); else st.hero = false;
      if (grid) io.observe(grid);
    }
    window.addEventListener('aftersell-upcart:public-events:cart-opened', function () { cartOpen = true; upd(); });
    window.addEventListener('aftersell-upcart:public-events:cart-closed', function () { cartOpen = false; upd(); });
    setInterval(upd, 700);
  }

  /* ---------------------------------------------------------------- media (clip band, LP film) */
  function initMedia(v) {
    if (v.__h26s) return; v.__h26s = true;
    var kind = v.getAttribute('data-h26s-video') || 'video';
    var saveData = false; try { saveData = !!(navigator.connection && navigator.connection.saveData); } catch (e) {}
    var auto = !reduce && !saveData;
    var loaded = false, userPaused = false, inView = false;
    // Oct 26 (REQ-010, Amir "go and build them all"): no auto-play until the page has finished loading, so the film
    // never competes with the first screen on a phone. The play button still starts it at once.
    var pageReady = document.readyState === 'complete';
    if (!pageReady) window.addEventListener('load', function () { pageReady = true; if (inView && auto && !userPaused) play('auto'); }, { once: true });
    var pp = v.parentNode && $('[data-h26s-film-pp]', v.parentNode);
    var big = v.parentNode && $('[data-h26s-film-big]', v.parentNode);
    // Oct 19 (Amir): a video with its own poster (the collection band) stays visible, so the poster shows until it plays.
    if (!v.hasAttribute('poster')) v.style.opacity = '0';
    // Controls: while playing, the small pause button; otherwise the big play button.
    function showCtl(playing) { if (big) big.hidden = playing; if (pp) pp.hidden = !playing; setPP(); }
    v.addEventListener('playing', function () { v.style.opacity = '1'; showCtl(true); });
    v.addEventListener('pause', function () { showCtl(false); });
    function load() {
      if (loaded) return; loaded = true;
      var narrow = !isDesk();
      var srcs = $$('source', v);
      var pick = srcs.filter(function (s) { return narrow ? s.hasAttribute('data-narrow') : !s.hasAttribute('data-narrow'); });
      if (!pick.length) pick = srcs;
      pick.sort(function (a, b) { return (+a.getAttribute('data-h') || 0) - (+b.getAttribute('data-h') || 0); });
      var target = narrow ? 720 : 1080;
      var best = pick.filter(function (s) { return (+s.getAttribute('data-h') || 0) <= target; }).pop() || pick[0];
      if (best) v.src = best.getAttribute('data-src');
    }
    function setPP() {
      if (!pp) return;
      var paused = v.paused;
      pp.setAttribute('aria-pressed', String(paused));
      pp.setAttribute('aria-label', paused ? (pp.getAttribute('data-label-play') || '') : (pp.getAttribute('data-label-pause') || ''));
    }
    function play(m) {
      load();
      var p = v.play();
      if (p && p.then) p.then(function () { setPP(); track('media_play', { target: kind, method: m }, v); }).catch(function () { showCtl(false); });
    }
    function pause(m) { if (v.paused) return; v.pause(); setPP(); track('media_pause', { target: kind, method: m }, v); }
    if (big) {
      big.addEventListener('click', function () { userPaused = false; play('button'); });
      if (!auto || !('IntersectionObserver' in window)) big.hidden = false;
    }
    if (pp) {
      pp.addEventListener('click', function () {
        if (v.paused) { userPaused = false; play('button'); } else { userPaused = true; pause('button'); }
      });
      setPP();
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          inView = e.isIntersecting && e.intersectionRatio >= 0.5;
          if (inView && auto && !userPaused && pageReady) play('auto');
          else if (!inView) pause('offscreen');
        });
      }, { threshold: [0, 0.5] }).observe(v.parentNode || v);
    }
  }

  /* ---------------------------------------------------------------- early access (collection hero) */
  function initEA(h) {
    var mode = h.getAttribute('data-mode'), ends = Date.parse(h.getAttribute('data-ends') || '');
    var ea = mode === 'on' || (mode === 'auto' && !isNaN(ends) && Date.now() < ends);
    $$('[data-h26s-ea-show]', h).forEach(function (x) { x.hidden = (x.getAttribute('data-h26s-ea-show') === 'ea') !== ea; });
    if (mode === 'auto' && ea && !isNaN(ends)) {
      var ms = ends - Date.now();
      if (ms > 0 && ms < 2147483000) setTimeout(function () { initEA(h); }, ms + 500);
    }
  }

  /* ---------------------------------------------------------------- live-card free-shipping pill */
  // The live card (product-grid-item) shows "Free Shipping" at a hardcoded 11000 in any currency
  // (discovery F5). On these pages that pill is removed and shown again only when the price meets
  // the market's Ship window threshold in the cart's currency (data-h26s-thr; blank = never).
  // Record in another currency (data-h26-thr-src): the threshold comes from the browser conversion
  // (assets/h26-threshold.js, approximate); until it resolves, and if it fails, no pill shows.
  function fixPills(root) {
    $$('[data-h26s-thr]', root).forEach(function (sec) {
      if (!sec.getAttribute('data-h26s-thr') && sec.hasAttribute('data-h26-thr-src') && window.H26Thr && !sec.__h26thrWait) {
        sec.__h26thrWait = true;
        window.H26Thr.resolve(sec).then(function (res) {
          if (!res) return;
          sec.setAttribute('data-h26s-thr', String(res.cents));
          sec.setAttribute('data-h26s-thr-approx', res.approx ? '1' : '');
          fixPills(sec.parentNode || document);
        });
      }
      var thr = parseInt(sec.getAttribute('data-h26s-thr'), 10), label = sec.getAttribute('data-h26s-pill') || '';
      var apx = sec.getAttribute('data-h26s-thr-approx') === '1';
      $$('.oo-gpi-pills', sec).forEach(function (box) {
        $$('.oo-gpi-pill', box).forEach(function (p) { if (/^\s*free shipping\s*$/i.test(p.textContent) && !p.hasAttribute('data-h26s')) p.parentNode.removeChild(p); });
        var gi = box.closest('[data-price]'), card = box.closest('.grid-product');
        var price = gi ? +gi.getAttribute('data-price') : NaN;
        var sold = card && card.querySelector('.oo-gpi-btn--notify');
        if (label && thr > 0 && price >= thr && !sold && !box.querySelector('[data-h26s]') && box.children.length < 2) {
          var s = document.createElement('span'); s.className = 'oo-gpi-pill'; s.setAttribute('data-h26s', ''); if (apx) s.setAttribute('data-h26-threshold-approx', '1'); s.textContent = label; box.appendChild(s);
        }
      });
      sec.classList.add('is-pilled');
    });
  }

  /* ---------------------------------------------------------------- ship cutoff (record) */
  // Lines from the Ship window record: promise_line before the record's cutoff_at, its
  // after_cutoff_line after it. Past the cutoff with no after line, the promise is hidden (a stale
  // promise never shows). Checked in the browser, because cached Liquid can be stale.
  // Review GPT-1-02 round 2: re-checked at the cutoff itself (timer, when under 24 days away) and when the tab
  // comes back or the page is restored, so a page left open across the cutoff switches too.
  var cutTimer = null;
  function cutWatch() {
    var next = Infinity;
    $$('[data-h26-ship-cutoff]', document).forEach(function (el) {
      var t = Date.parse((el.getAttribute('data-h26-ship-cutoff') || '').replace(/([+-]\d{2})(\d{2})$/, '$1:$2'));
      if (!isNaN(t) && t > Date.now() && t < next) next = t;
    });
    if (cutTimer) { clearTimeout(cutTimer); cutTimer = null; }
    var wait = next - Date.now() + 1000;
    if (isFinite(next) && wait > 0 && wait < 2073600000) cutTimer = setTimeout(function () { initCutoff(document); cutWatch(); }, wait);
  }
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') { try { initCutoff(document); cutWatch(); } catch (e) {} } });
  window.addEventListener('pageshow', function () { try { initCutoff(document); cutWatch(); } catch (e) {} });
  function initCutoff(root) {
    $$('[data-h26-ship-cutoff]', root).forEach(function (el) {
      var raw = (el.getAttribute('data-h26-ship-cutoff') || '').replace(/([+-]\d{2})(\d{2})$/, '$1:$2');
      var t = Date.parse(raw);
      if (isNaN(t)) return;
      var after = Date.now() >= t;
      var hasAfter = !!$('[data-h26s-cut="after"]', el);
      $$('[data-h26s-cut]', el).forEach(function (x) {
        var isAfter = x.getAttribute('data-h26s-cut') === 'after';
        x.hidden = after ? !isAfter : isAfter;
      });
      if (after && !hasAfter && el.matches('.h26s-hship')) el.hidden = true;
    });
  }

  /* ---------------------------------------------------------------- links, jumps */
  function initLinks(root) {
    $$('[data-h26s-oo-src]', root).forEach(function (r) {
      var v = r.getAttribute('data-h26s-oo-src');
      $$('a[href*="/products/"]', r).forEach(function (a) {
        if (a.getAttribute('href').indexOf('oo_src=') !== -1) return;
        try { var u = new URL(a.getAttribute('href'), location.href); u.searchParams.set('oo_src', v); a.setAttribute('href', u.pathname + u.search + u.hash); } catch (e) {}
      });
    });
  }
  document.addEventListener('click', function (e) {
    var j = e.target.closest && e.target.closest('[data-h26s-jump]');
    if (j) {
      var el = document.getElementById(j.getAttribute('data-h26s-jump'));
      if (el) { e.preventDefault(); el.scrollIntoView({ block: 'start', behavior: behavior() }); }
      return;
    }
    var go = e.target.closest && e.target.closest('[data-h26s-go]');
    if (go) {
      var g = GRIDS[0];
      if (g && g.__setTab) { g.__setTab(go.getAttribute('data-h26s-go')); g.scrollIntoView({ block: 'start', behavior: behavior() }); }
      return;
    }
    var a = e.target.closest && e.target.closest('.h26s a[href*="/products/"]');
    if (a && !a.hasAttribute('data-h26-event')) {
      var c = a.closest('[data-h26-product-id],[data-product-id],[data-pid]');
      var pid = c && (c.getAttribute('data-h26-product-id') || c.getAttribute('data-product-id') || c.getAttribute('data-pid'));
      // Test 4: the visible position, when the row carries it (snippets/oo-ab-sets); absent elsewhere, so the payload is unchanged
      var ix = a.closest('[data-h26-index]');
      track('card_click', { target: pid, index: ix ? ix.getAttribute('data-h26-index') : null }, a);
    }
  }, true);

  /* ---------------------------------------------------------------- init */
  function init(root) {
    root = root || document;
    $$('[data-h26s-ea]', root).forEach(initEA);
    $$('[data-h26s-car]', root).forEach(initCar);
    $$('[data-h26s-ms]', root).forEach(initMs);
    $$('[data-h26s-rv]', root).forEach(initRv);
    $$('[data-h26s-grid]', root).forEach(initGrid);
    $$('[data-h26s-farmers]', root).forEach(initFarmers);
    $$('[data-h26s-taste]', root).forEach(initTaste);
    $$('[data-h26s-stk]', root).forEach(initSticky);
    $$('video[data-h26s-video]', root).forEach(initMedia);
    initLinks(root);
    initCutoff(root); try { cutWatch(); } catch (e) {}
    fixPills(root);
    toolbarTop();
    syncSources();
  }
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () { ticking = false; toolbarTop(); });
  }, { passive: true });
  ['aftersell-upcart:public-events:cart-updated', 'aftersell-upcart:public-events:added-to-cart', 'aftersell-upcart:public-events:cart-loaded'].forEach(function (n) {
    window.addEventListener(n, syncSources);
  });
  document.addEventListener('h26:atc', syncSources);

  /* ---------------------------------------------------------------- live cards: add intent (DE audit P15, 2026-10-17; runbook 27d) */
  // Live cards (grid, spices rows) add through UpCart, not h26-atc, so no oo_atc_result fires for them. Publish the
  // intent with the card's placement; Shopify's product_added_to_cart (same client, seconds later) confirms the add.
  document.addEventListener('submit', function (e) {
    try {
      var f = e.target && e.target.closest ? e.target.closest('.h26s [data-oo-atc-form]') : null;
      if (!f) return;
      var id = $('[name="id"]', f), q = $('[name="quantity"]', f), s = $('[name="properties[_source]"]', f);
      track('atc_submit', { variant_id: id && id.value, quantity: q ? q.value : 1, source: s && !s.disabled ? s.value : null }, f);
    } catch (err) {}
  }, true);

  window.OOH26S = { init: init, sync: syncSources };
  function boot() {
    init(document);
    if (CFG.page === 'h26-lp') {
      var f = {};
      try {
        var q = new URLSearchParams(location.search);
        ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'ad_id', 'adset_id'].forEach(function (k) { var v = q.get(k); if (v) f[k] = v; });
      } catch (e) {}
      track('landing', f, document.querySelector('[data-asset-id="h26-lp-hero-film"]'));
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
